import { render } from "./NewTestamentChallenge.vue?vue&type=template&id=2e9e6254&ts=true"
import script from "./NewTestamentChallenge.vue?vue&type=script&lang=ts"
export * from "./NewTestamentChallenge.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__